import { NetworkConfigType, NetworkInfoType } from "./types";

// Images
import maticIcon from "assets/svg/matic-circular.svg";
import maticDarkIcon from "assets/svg/matic-dark.svg";
import maticxIcon from "assets/svg/maticx.svg";
import maticxDarkIcon from "assets/svg/maticx-dark.svg";

// ABI
import ERC20TOKENABI from "contracts/polygon/ERC20.json";
import TokenXBalABI from "contracts/polygon/TokenXBal.json";
import TokenXChildPoolABI from "contracts/polygon/TokenXInteractionPool.json";
import TokenStakeManagerABI from "contracts/polygon/ERC20StakeManager.json";

const providerKey = process.env.NEXT_PUBLIC_ALCHEMY_KEY || "";

export const PolygonTestNetConfig: NetworkConfigType = {
  chainId: "0x89",
  supportedChainIDs: [1, 137],
  providerKey,
  chainName: "Polygon Testnet",
  nativeCurrency: {
    name: "Polygon",
    symbol: "Matic",
    xsymbol: "MaticX",
    decimals: 18,
  },
  blockExplorerUrls: ["https://polygonscan.com"],
  contractAddresses: {
    erc20: "0xfa68fb4628dff1028cfec22b4162fccd0d45efb6",
    xtoken: {
      token: "0xfa68fb4628dff1028cfec22b4162fccd0d45efb6",
      interactionPool: "0xD0E7baf4750710A0dcC91A0b11DC8f02504d7e7D",
    },
    sfc: "0x5e3Ef299fDDf15eAa0432E6e66473ace8c13D908",
  },
  abis: {
    erc20: ERC20TOKENABI,
    xtoken: {
      token: TokenXBalABI,
      interactionPool: TokenXChildPoolABI,
    },
    sfc: TokenStakeManagerABI,
  },
};

export const NetworkInfo: NetworkInfoType = {
  icon: {
    light: maticIcon,
    dark: maticDarkIcon,
  },
  tokenXIcon: {
    light: maticxIcon,
    dark: maticxDarkIcon,
  },
};
